import { inRange } from 'lodash';
import { BillingCycle, BillingVersion, MonthlyPrice, PlanHierarchy, PlanIds, PlanNames, RestrictedPlans, SupportedPlans, YearlyPrice } from 'api/billing/types';
import { capitalizeFirstLetter, capitalizeFirstLetterOfEachWord } from 'utils/string-utils';
export const getBillingVersion = (planId)=>{
    return inRange(planId, 11, 24) ? BillingVersion.v2 : BillingVersion.v1;
};
export const getSupportedPlanName = (planName)=>{
    var _planName_toString_split, _planName_toString;
    return SupportedPlans === null || SupportedPlans === void 0 ? void 0 : SupportedPlans[planName === null || planName === void 0 ? void 0 : (_planName_toString = planName.toString()) === null || _planName_toString === void 0 ? void 0 : (_planName_toString_split = _planName_toString.split('_')) === null || _planName_toString_split === void 0 ? void 0 : _planName_toString_split[0]];
};
export const getPlanName = (planName)=>{
    var _planName_toString_split, _planName_toString;
    return getSupportedPlanName(planName) || (RestrictedPlans === null || RestrictedPlans === void 0 ? void 0 : RestrictedPlans[planName === null || planName === void 0 ? void 0 : (_planName_toString = planName.toString()) === null || _planName_toString === void 0 ? void 0 : (_planName_toString_split = _planName_toString.split('_')) === null || _planName_toString_split === void 0 ? void 0 : _planName_toString_split[0]]);
};
export const getCurrentBillingCycle = (planName)=>{
    var _planName_toString_split, _planName_toString;
    return BillingCycle === null || BillingCycle === void 0 ? void 0 : BillingCycle[planName === null || planName === void 0 ? void 0 : (_planName_toString = planName.toString()) === null || _planName_toString === void 0 ? void 0 : (_planName_toString_split = _planName_toString.split('_')) === null || _planName_toString_split === void 0 ? void 0 : _planName_toString_split[1]];
};
export const getYearlySavings = (planName, quantity)=>{
    const plan = SupportedPlans === null || SupportedPlans === void 0 ? void 0 : SupportedPlans[planName];
    if (!plan) {
        return 0;
    }
    return (MonthlyPrice === null || MonthlyPrice === void 0 ? void 0 : MonthlyPrice[plan]) * quantity * 12 - YearlyPrice[plan] * quantity * 12;
};
export const getNextPlan = (currentPlan)=>{
    const version = getBillingVersion(currentPlan.planId);
    const planName = getPlanName(currentPlan.planName);
    const _planHierarchy = PlanHierarchy[version];
    if (!(_planHierarchy === null || _planHierarchy === void 0 ? void 0 : _planHierarchy[planName])) {
        return undefined;
    }
    return SupportedPlans[_planHierarchy[_planHierarchy[planName] + 1]];
};
/**
 * toLocaleString adds comma separator by en-US locale by default.
 */ export const formatAmount = (amount)=>`${Math.round(amount / 100).toLocaleString()}`;
export const formatInvoiceAmount = (invoice)=>`${formatAmount(invoice.invoiceTotal)} ${invoice.currencyCode}`;
export const getPlanPrice = (planName)=>{
    const plan = getPlanName(planName);
    const billingCycle = getCurrentBillingCycle(planName);
    return billingCycle === BillingCycle.Monthly ? MonthlyPrice[plan] : YearlyPrice[plan];
};
export const getPlanId = (plan, billingCycle)=>PlanIds[`${capitalizeFirstLetter(plan)}_${capitalizeFirstLetterOfEachWord(billingCycle)}`];
export const getPlanNameWithCycle = (plan, billingCycle)=>PlanNames[PlanIds[getPlanId(plan, billingCycle)]];
